import { string, func } from "prop-types";
import Icon from "../../Icon/Icon.jsx";
import useCookie from "../../../../../Common/js/common/useCookie.jsx";
import cx from "classnames";

const propTypes = {
  message: string.isRequired,
  link: string,
  backgroundColor: string,
  setSitewideAlert: func,
};

const SitewideAlert = (props) => {
  const { link, message, backgroundColor, setSitewideAlert } = props;

  // get the cookie -- if no cookie, set to the string "false"
  const [cookieWasAlertViewed, updateAlertViewCookie] = useCookie(
    "wasAlertViewed",
    "false",
  );

  const handleCloseButtonClick = (event) => {
    updateAlertViewCookie("true");
    setSitewideAlert(true);
  };

  return (
    <div
      className={cx("sitewide-alert", {
        "sitewide-alert--open": cookieWasAlertViewed === "false",
        "sitewide-alert--teal":
          "teal".localeCompare(backgroundColor, "en", {
            sensitivity: "accent",
          }) === 0,
      })}
    >
      <p className="sitewide-alert__message">
        <span className="visually-hidden">Message: </span>
        {link ? (
          <a href={link} className="sitewide-alert__link">
            {message}
            <Icon
              iconName="arrow-right"
              className="sitewide-alert__link-arrow"
            />
          </a>
        ) : (
          { message }
        )}
        <button
          type="button"
          className="btn sitewide-alert__close-button"
          onClick={handleCloseButtonClick}
          aria-label="Close Message"
        >
          <Icon iconName="close-x" />
        </button>
      </p>
    </div>
  );
};

SitewideAlert.propTypes = propTypes;
export default SitewideAlert;
